import type { TypographyOptions } from '@mui/material/styles/createTypography'
import { DENSITY, densityRem } from './density'

export const createTypography = (): TypographyOptions => {
  return {
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
    // Référence pxToRem : ne pas la baisser ici (cela fausserait les rem calculés depuis des px).
    fontSize: 12,
    body1: {
      fontSize: densityRem(1),
      fontWeight: 400,
      lineHeight: 1.4,
    },
    body2: {
      fontSize: densityRem(0.875),
      fontWeight: 400,
      lineHeight: 1.57,
    },
    button: {
      fontWeight: 600,
    },
    caption: {
      fontSize: densityRem(0.75),
      fontWeight: 500,
      lineHeight: 1.66,
    },
    subtitle1: {
      fontSize: densityRem(1),
      fontWeight: 500,
      lineHeight: 1.57,
    },
    subtitle2: {
      fontSize: densityRem(0.875),
      fontWeight: 500,
      lineHeight: 1.57,
    },
    overline: {
      fontSize: densityRem(0.75),
      fontWeight: 600,
      letterSpacing: `${Math.round(0.5 * DENSITY * 10) / 10}px`,
      lineHeight: 2.5,
      textTransform: 'uppercase',
    },
    h1: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontWeight: 700,
      fontSize: densityRem(3.5),
      lineHeight: 1.2,
    },
    h2: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontWeight: 700,
      fontSize: densityRem(2.5),
      lineHeight: 1.2,
    },
    h3: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontWeight: 700,
      fontSize: densityRem(2),
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontWeight: 700,
      fontSize: densityRem(1.8),
      lineHeight: 1.2,
    },
    h5: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontWeight: 700,
      fontSize: densityRem(1.3),
      lineHeight: 1.2,
    },
    h6: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontWeight: 700,
      fontSize: densityRem(1.125),
      lineHeight: 1.2,
    },
  }
}
